import React from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

// inspired from https://reactjs.org/docs/error-boundaries.html

class ErrorBoundary extends React.Component {
	state = { error: null, errorInfo: null };

	// static getDerivedStateFromError(error) {
	// 	// Update state so the next render will show the fallback UI.
	// 	return { hasError: true };
	// }

	componentDidCatch(error, errorInfo) {
		// Catch errors in any components below and re-render with error message
		this.setState({
			error: error,
			errorInfo: errorInfo,
		});
		// You can also log error messages to an error reporting service here
	}

	copyToClipboard = () => {
		const text = `
      ${window.location.href}
      ${this.state.error && this.state.error.toString()}
      ${this.state.errorInfo.componentStack}
    `;
		clipboardCopy(text);
	};

	render() {
		if (this.state.errorInfo) {
			// Error path
			return (
				<div className="app flex-row align-items-center">
					<Container>
						<Row className="justify-content-center">
							<Col md="6">
								<div className="clearfix">
									<h1 className="float-left display-3 mr-4">Error</h1>
									<h4 className="pt-3">Oops! Something went wrong.</h4>
									<p className="text-muted float-left">
										The page cannot be rendered.
									</p>
								</div>
								<div className="d-flex mt-2 mb-2">
									<h6 className="text-primary mt-1 mb-1">
										Copy error details with stack trace
									</h6>

									<Button
										size="sm"
										color="primary"
										className="ml-4"
										onClick={() => this.copyToClipboard()}
									>
										Copy to clipboard
									</Button>
								</div>

								<details style={{ whiteSpace: 'pre-wrap' }}>
									{this.state.error && this.state.error.toString()}
									<br />
									{this.state.errorInfo.componentStack}
								</details>
							</Col>
						</Row>
					</Container>
				</div>
			);
		}

		return this.props.children;
	}
}

function clipboardCopy (text) {
  // Use the Async Clipboard API when available. Requires a secure browsing
  // context (i.e. HTTPS)
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(text).catch(function (err) {
      throw (err !== undefined ? err : new DOMException('The request is not allowed', 'NotAllowedError'))
    })
  }

  // ...Otherwise, use document.execCommand() fallback

  // Put the text to copy into a <span>
  var span = document.createElement('span')
  span.textContent = text

  // Preserve consecutive spaces and newlines
  span.style.whiteSpace = 'pre'

  // Add the <span> to the page
  document.body.appendChild(span)

  // Make a selection object representing the range of text selected by the user
  var selection = window.getSelection()
  var range = window.document.createRange()
  selection.removeAllRanges()
  range.selectNode(span)
  selection.addRange(range)

  // Copy text to the clipboard
  var success = false
  try {
    success = window.document.execCommand('copy')
  } catch (err) {
    console.log('error', err)
  }

  // Cleanup
  selection.removeAllRanges()
  window.document.body.removeChild(span)

  return success
    ? Promise.resolve()
    : Promise.reject(new DOMException('The request is not allowed', 'NotAllowedError'))
}

export default ErrorBoundary;
